export default __webpack_public_path__ + "upload/andrey.1a0e8f78.pdf";